import { DatesFilter } from './dates-filter';
import { EmailStatusFilter } from './email-status-filter';
import { AnswerFilter } from './answer-filter';
import { SynchronizationFilter } from './synchronization-filter';

export class SearchFilters {

    constructor() {
        this.addEmptyAnswerFilter();
    }
    datesFilter:DatesFilter = new DatesFilter();
    emailStatusFilter:EmailStatusFilter = new EmailStatusFilter();
    synchronizationFilter:SynchronizationFilter = new SynchronizationFilter();
    answersFilter: AnswerFilter[] = [];

    static isValid() {
         return true;
    }

    initFromJson(json) {
        this.datesFilter.initFromJson(json.datesFilter);
        this.emailStatusFilter.initFromJson(json.emailStatusFilter);
        this.synchronizationFilter.initFromJson(json.synchronizationFilter);

        // TODO AnswerFilter
        const answers = json.answersFilter;
        if (answers.length > 0) {
            this.answersFilter.pop();
        }

        for (let i = 0; i < answers.length; i++) {
            const af = new AnswerFilter();
            af.initFromJson(answers[i]);
            this.answersFilter.push(af);
        }
    }

    addEmptyAnswerFilter() {
        this.answersFilter.push(new AnswerFilter());
    }

    isEmpty() {
        if (!this.datesFilter.isEmpty()) {
            return false;
        }

        if (!this.emailStatusFilter.isEmpty()) {
            return false;
        }

        if (!this.synchronizationFilter.isEmpty()) {
            return false;
        }

        for (let i = 0; i < this.answersFilter.length; i++) {
            if (!this.answersFilter[i].isEmpty()) {
                return false;
            }
        }

        return true;
    }

}
